import { render } from "./CreateMoyenPaiement.vue?vue&type=template&id=0cb4dc7c&scoped=true"
import script from "./CreateMoyenPaiement.vue?vue&type=script&lang=js"
export * from "./CreateMoyenPaiement.vue?vue&type=script&lang=js"

import "./CreateMoyenPaiement.vue?vue&type=style&index=0&id=0cb4dc7c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cb4dc7c"]])

export default __exports__